// matchMedia is absent in jsdom, so treat "can't tell" as "motion is fine".
//
// Shared because every autoplaying marketing clip on the site owes the visitor
// the same contract: no looping motion under `prefers-reduced-motion: reduce`
// (WCAG 2.2.2 wants a pause control on anything auto-starting past 5s), and a
// way back to playback when the browser refuses autoplay outright.
const prefersReducedMotion = () =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

export default prefersReducedMotion;
